import React from 'react';
import PropTypes from 'prop-types';

class YociteEmbed extends React.Component {
  constructor(props) {
    super(props);
    this.container = null;
    this.setContainerRef = this.setContainerRef.bind(this);
    this.inject = this.inject.bind(this);
  }

  setContainerRef(el) {
    this.container = el;
  }

  inject() {
    var el = this.container;
    var id = this.props.id;
    var theme = this.props.theme || 'light';
    if (!el || !id) return;

    // Clear previous content
    while (el.firstChild) el.removeChild(el.firstChild);

    // Inject script
    var s = document.createElement('script');
    s.src = 'https://cdn.yocite.com/embed.js';
    s.async = true;
    s.setAttribute('data-id', id);
    // s.setAttribute('data-theme', theme);
    el.appendChild(s);
  }

  componentDidMount() {
    this.inject();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id || prevProps.theme !== this.props.theme) {
      this.inject();
    }
  }

  componentWillUnmount() {
    var el = this.container;
    if (el) {
      while (el.firstChild) el.removeChild(el.firstChild);
    }
  }

  render() {
    return <div ref={this.setContainerRef} />;
  }
}

YociteEmbed.propTypes = {
  id: PropTypes.string.isRequired,
  // theme: PropTypes.oneOf(['light', 'dark'])
};

// YociteEmbed.defaultProps = {
//   theme: 'light'
// };

export default YociteEmbed;
